import { isPast, isSameDay } from "date-fns";
import { array, boolean, date, mixed, object, ObjectSchema, string } from "yup";

import { FormErrorMessage } from "~/constants/messages";
import { katakanaRegexp, mobilePhoneRegexp } from "~/constants/regexp";
import { Sex } from "~/graphql";

import { Answers, Fields } from "./types";

export const MAX_FILES = 15;
export const MAX_ANSWER_LENGTH = 300;
const MIN_FILES = 1;
const TODAY = new Date();

const validationAnswersSchema: ObjectSchema<Answers> = object({
  question1: object().shape({
    title: string().required(FormErrorMessage.required),
    value: array()
      .required()
      .min(1)
      .of(string().required(FormErrorMessage.required)),
  }),
  question2: object().shape({
    title: string().required(FormErrorMessage.required),
    value: array()
      .required()
      .min(1)
      .of(string().required(FormErrorMessage.required)),
  }),
  question3: object().shape({
    title: string().required(FormErrorMessage.required),
    value: array()
      .required()
      .min(1)
      .of(string().required(FormErrorMessage.required)),
  }),
  question4: object().shape({
    title: string().required(FormErrorMessage.required),
    value: array()
      .required()
      .min(1)
      .of(string().required(FormErrorMessage.required)),
  }),
  question5: object().shape({
    title: string().required(FormErrorMessage.required),
    value: array()
      .required()
      .of(
        mixed<string>()
          .required()
          .test(
            "回答",
            `${MAX_ANSWER_LENGTH}文字以内で入力してください`,
            (answer: string) =>
              answer ? answer.length <= MAX_ANSWER_LENGTH : true,
          ),
      ),
  }),
});

export const validationSchema: ObjectSchema<Fields> = object({
  date: date().label("希望日").required(FormErrorMessage.required),
  startTime: string().label("希望開始時間").required(FormErrorMessage.required),
  endTime: string().label("希望終了時間").required(FormErrorMessage.required),
  prescriptions: array()
    .label("処方箋")
    .min(MIN_FILES, "${min}枚以上の処方箋をアップロードしてください")
    .max(MAX_FILES, "処方箋は${max}枚以内に収めてください")
    .required(FormErrorMessage.required),
  familyName: string().label("姓").required(FormErrorMessage.required),
  givenName: string().label("名").required(FormErrorMessage.required),
  phoneticFamilyName: string()
    .label("姓（カナ）")
    .matches(katakanaRegexp, FormErrorMessage.invalid)
    .required(FormErrorMessage.required),
  phoneticGivenName: string()
    .label("名（カナ）")
    .matches(katakanaRegexp, FormErrorMessage.invalid)
    .required(FormErrorMessage.required),
  birthDate: string()
    .label("生年月日")
    .test("birthDate", FormErrorMessage.invalidBithDate, (birthDate) => {
      if (!birthDate) return true;

      const date = new Date(birthDate);
      return isPast(date) || isSameDay(date, TODAY);
    })
    .required(FormErrorMessage.required),
  sex: string()
    .label("性別")
    .oneOf(Object.values(Sex))
    .required(FormErrorMessage.required),
  mobilePhone: string()
    .label("携帯電話番号")
    .matches(mobilePhoneRegexp, FormErrorMessage.invalid)
    .required(FormErrorMessage.required),
  answers: validationAnswersSchema,
  isAgreed: boolean()
    .label("利用規約及びプライバシーポリシーの同意")
    .oneOf([true], "利用規約とプライバシーポリシーに同意してください")
    .required(FormErrorMessage.required),
});
